import { getEnvironmentVariable } from '../../services/env';

export const getApiEmbedUwAssets = () =>
  getEnvironmentVariable('EMBED_UW_ASSETS') === true ||
  getEnvironmentVariable('EMBED_UW_ASSETS') === 'true'
    ? '?embed=true'
    : '';

export const downloadFile = async (axiosInstance, url, downloadHandlerFn) => {
  try {
    const response = await axiosInstance.get(url, { responseType: 'blob' });
    const fileName = getFilenameFromResponseHeaders(response.headers);
    return downloadHandlerFn(response.data, fileName);
  } catch (error) {
    console.log('Error getting file', error);
  }
};

/**
 * Extract a file name from response headers
 *
 * @param {headers}
 * @returns {String}
 */
export const getFilenameFromResponseHeaders = (headers) => {
  try {
    return headers['content-disposition']
      .replace(/"/g, '')
      .split('filename=')[1]
      .split(';')[0];
  } catch (error) {
    throw new Error('Error retrieving filename from headers');
  }
};

export const buildUrlNbj1ApplicationAnswers = (
  applicationId,
  interviewId,
  interviewToken,
  adviserId
) => {
  let url = `document/interview/${interviewId}/${interviewToken}/applicationanswers?fileName=${applicationId}-application-answers`;
  url = !adviserId ? url : `${url}&adviserId=${adviserId}`;
  return url;
};

export const apiBaseUrl = getEnvironmentVariable('API_BASE_URL');
